define((require) => {
    "use strict";

    const {find}              = require("underscore");
    const ChannelBookmarklet  = require("ui/publish/channelSetup/ChannelBookmarklet");
    const ImprovedModel       = require("shared/zbone/ImprovedModel");
    const LoggedIn            = require("shared/security/LoggedIn");
    const RestApi             = require("shared/services/RestApi");
    const SyncManager         = require("shared/services/sync/SyncManager");
    const Permissions         = require("shared/security/Permissions");
    const Publishables        = require("ui/publish/Publishables");
    const Syncer              = require("shared/services/sync/Syncer");
    const UrlUtil             = require("shared/util/UrlUtil");

    /**
     * @class {ChannelConfig}
     *
     * Editor type only, viewer uses representation from S3.
     */
    return ImprovedModel.extend("Slot Configuration", { // channels are called slots in user terminology!

        defaults: {
            version: null,
            companyId: null
        },

        updateOnSync: ["purgeTime", "channels"],

        clearOnClone(options) {
            if (options.sync) { // also for "marshal"
                return ["purgeTime"];
            }
        },

        computed: {
            bookmarklet: {
                deps: ["id"],
                value(id) {
                    return ChannelBookmarklet.fromId(id);
                }
            }
        },

        constructor() {
            this.__super();

            // Changing a channel config requires PUBLISH privilege (as well as CREATE)...
            Syncer.State.init(this, {
                permissions: {
                    save:    Permissions.Privileges.PUBLISH,
                    destroy: Permissions.Privileges.PUBLISH,
                    domain:  Permissions.Privileges.PUBLISH
                }
            });
        },

        url() {
            if (this.isNew()) {
                return RestApi.pathToCollection(RestApi.Collections.CHANNEL_CONFIG);
            }
            return RestApi.pathToSpecificResource(RestApi.Collections.CHANNEL_CONFIG, this.get("id"));
        },

        fetchNewUrl() {
            return RestApi.pathToCollectionOnResource(RestApi.Collections.COMPANIES, LoggedIn.companyId(), RestApi.Collections.CHANNEL_CONFIG);
        },

        toJSON() {
            const json = this.__super();

            json.channels = json.channels.map((channelJSON) => {
                if (!channelJSON.publishable) {
                    channelJSON.publishable = channelJSON.experience ? Publishables.toReference(channelJSON, "Experience") : Publishables.toReference(channelJSON, "BreakpointGroup");
                }

                // Below assignments are required because Channel in backend still uses a serializer expecting id, name and state,
                // but the new Channels API requires a type for any content (experiences and groups (can only be BreakpointGroup)
                // TODO Remove this when we get rid of channel config at all. MOS-3651.
                if (channelJSON.experience && !channelJSON.experience.type) {
                    channelJSON.experience.type = "Experience";
                }

                if (channelJSON.group && !channelJSON.group.type) {
                    channelJSON.group.type = "BreakpointGroup";
                }

                if (channelJSON.schedules && channelJSON.schedules.length === 1) {
                    const schedule = channelJSON.schedules[0];
                    if (schedule.experience) {
                        schedule.experience = Publishables.toReference(schedule.experience, "Experience");
                        delete schedule.group;
                    } else if (schedule.group) {
                        schedule.group = Publishables.toReference(schedule.group, "BreakpointGroup");
                        delete schedule.experience;
                    }
                }

                return channelJSON;
            });

            return json;
        },

        channelById(id) {
            return find(this.get("channels"), (channelJson) => (channelJson.id === id || channelJson.cid === id));
        },

        removeChannel(channelJson) {
            const channels = this.get("channels");
            const i = channels.indexOf(channelJson);

            if (i !== -1) {
                channels.splice(i, 1);
            }
        }
    }, {

        count(options) {
            let location = RestApi.Collections.CHANNEL_CONFIGS_COUNT;
            const project = options && options.project;

            if (project) {
                // projects/{ID}/channels/count
                location = RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, project.get("id"), RestApi.Collections.CHANNELS_COUNT);
            }

            return SyncManager.get(location, SyncManager.target("ChannelConfig.count"));
        },

        /**
         * Asynchronous fetching of channel config by type and Id
         * @param {string} type - examples: `Experience`, `Group`
         * @param {string} id mongo ObejctId - should be available under model.id
         * @returns {Promise<object[]>} promise resolving with a list of pieces of information about the channels the type and Id resolve to.
         */
        fetchByType(type, id) {
            const url = UrlUtil.appendParamObject(RestApi.Collections.CHANNEL_CONFIG_CHANNELS, {
                type,
                id
            });

            return SyncManager.get(url, SyncManager.target("ChannelConfig.fetchByType"));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/publish/channelSetup/ChannelConfig.js